import { render, staticRenderFns } from "./CompanyCourseFolders.vue?vue&type=template&id=64b18d06"
import script from "./CompanyCourseFolders.vue?vue&type=script&lang=js"
export * from "./CompanyCourseFolders.vue?vue&type=script&lang=js"
import style0 from "./CompanyCourseFolders.vue?vue&type=style&index=0&id=64b18d06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports